import "../css/Pragmatica.css";

export const getDesignTokens = (mode) => ({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    h4: {
      fontFamily: "Pragmatica, sans-serif",
    },
    h5: {
      fontFamily: "Pragmatica, sans-serif",
    },
    h6: {
      fontFamily: "Pragmatica, sans-serif",
    },
    h7: {
      fontFamily: "Pragmatica, sans-serif",
    },
    body1: {
      fontFamily: "Pragmatica, sans-serif",
      fontWeight: 300,
      fontSize: "1.1rem",
      lineHeight: "1.3",
    },
    body2: {
      fontFamily: "Pragmatica, sans-serif",
      fontWeight: 300,
      fontSize: "1.1rem",
      lineHeight: "1.3",
      marginBottom: "0.75rem",
    },
    caption: {
      fontFamily: "Pragmatica, sans-serif",
      fontWeight: 600,
      fontSize: "0.625rem",
      lineHeight: "1.3",
    },
  },
  shape: {
    borderRadius: 10,
  },
  palette: {
    mode,
    ...(mode === "light"
      ? {
          primary: {
            main: "#005eb8",
            light: "#3d8fd1",
            dark: "#003f7f",
            contrastText: "#FFF",
          },
          secondary: {
            main: "#28a745",
            light: "#5cb85c",
            dark: "#218838",
          },
          background: {
            default: "#F8FAFC",
            paper: "#FFFFFF",
          },
          text: {
            primary: "#1E293B",
            secondary: "#475569",
          },
        }
      : //Dark Mode
        {
          primary: {
            main: "#3d8fd1",
            light: "#6eb4e6",
            dark: "#005eb8",
          },
          secondary: {
            main: "#5cb85c",
            light: "#85d385",
            dark: "#28a745",
          },
          background: {
            default: "#0F172A",
            paper: "#1E293B",
          },
          text: {
            primary: "#F1F5F9",
            secondary: "#CBD5E1",
          },
        }),
  },
});

export const getThemedComponents = (mode) => ({
  components: {
    // Both Modes
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& input": {
            "&:-webkit-autofill": {
              transition:
                "background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s",
            },
          },
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        sx: {
          fontSize: "1.3rem",
          lineHeight: "1.75rem",
          fontWeight: 500,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& > fieldset > legend": {
            fontSize: `calc(0.75 * 1.3rem)`,
            fontWeight: 400,
          },
        },
      },
    },
    MuiRichTreeView: {
      styleOverrides: {
        root: {
          "& .MuiTreeItem-label": {
            fontSize: "1rem!important",
          },
        },
      },
    },
    // Customize Links to appear as Chips
    MuiLink: {
      defaultProps: {
        underline: "none",
      },
      styleOverrides: {
        root: {
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          borderRadius: "16px",
          backgroundColor: mode === "light" ? "#005eb8" : "#3d8fd1",
          color: mode === "light" ? "#FFF" : "#0F172A",
          fontWeight: 500,
          fontSize: "0.875rem",
          transition: "background-color 0.3s ease",
          cursor: "pointer",
          textDecoration: "none",
          "&:hover": {
            backgroundColor: mode === "light" ? "#003f7f" : "#6eb4e6",
            textDecoration: "none",
          },
          "&:focus": {
            outline: "none",
            boxShadow:
              mode === "light"
                ? "0 0 0 2px rgba(0, 94, 184, 0.5)"
                : "0 0 0 2px rgba(61, 143, 209, 0.5)",
          },
        },
      },
    },
  },
});
